import script from "./DataCollect.vue?vue&type=script&setup=true&lang=js"
export * from "./DataCollect.vue?vue&type=script&setup=true&lang=js"

import "./DataCollect.vue?vue&type=style&index=0&id=535ce862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535ce862"]])

export default __exports__